import { Modal } from "antd";
import React, { useEffect, useRef } from "react";
import UpsertInfo from "../ConfirmationModal/UpsertInfo";
import { Button } from "antd";

import styles from './index.module.scss';

interface Props {
  name: string;
  visible: boolean;
  onCancel(): void;
  okText: string;
  cancelText: string;
  onOk(): void;
  loading?: boolean;
}

export enum AfterActions {
  STAY = 'STAY',
  BACK = 'BACK',
}
const usePrevious = (value: boolean) => {
  const ref = useRef<boolean>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const DialogPopUpConfirmation: React.FunctionComponent<Props> = ({
  name,
  visible,
  onCancel,
  cancelText,
  okText,
  onOk,
  loading = false,
}) => {
  const prevVisible = usePrevious(visible);
  useEffect(() => {

    if (prevVisible && !visible) {
      onCancel();
    }
  }, [prevVisible, visible, onCancel]);

  return visible ?
    <Modal
      visible={visible}
      closable={false}
      centered={true}
      footer={null}
      maskClosable={true}
      width={450}
      onCancel={onCancel}
    >
      <UpsertInfo
        msgLine1={name}
        msgLine2=""
        alt={`${name}`}
      />
      <div className={styles.buttons}>
        <Button loading={loading} disabled={loading} type="link" onClick={onCancel}>{cancelText}</Button>
        <Button loading={loading} disabled={loading} type="primary" onClick={onOk}>{okText}</Button>
      </div>
    </Modal>
    : null;
};
